module.exports = __webpack_public_path__ + "img/8L.8c2e1d0f.png";